<template>
  <CategoryFaqLayout
    :label="label"
    :category-info="author"
    :prev-route-link="prevRouteLink"
    :books-counter="booksCounter"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import SessionStorageService from '@/services/SessionStorageService';

import CategoryFaqLayout from '@/components/views/CategoryView/CategoryFaqLayout.vue';

export default {
  name: 'AuthorFaqView',
  components: {
    CategoryFaqLayout
  },
  props: {
    author: Object,
    booksCounter: [Number, String]
  },
  computed: {
    ...mapGetters('LibraryStore', ['searchPublications']),
    prevRouteLink() {
      const prevRoute = this.$store.state.ContextStore.previousNotAuthorRoute;
      const storedPrevRoute = SessionStorageService.get('previousRoute');

      let actualPrevRoute;
      if (prevRoute?.name) {
        actualPrevRoute = prevRoute;
      } else if (storedPrevRoute?.name) {
        actualPrevRoute = storedPrevRoute;
      }
      return actualPrevRoute;
    },
    label() {
      return this.author?.name ?? '';
    }
  },
  destroyed() {
    SessionStorageService.set(
      'previousRoute',
      this.$store.state.ContextStore.previousNotAuthorRoute
    );
  }
};
</script>

<style lang="less"></style>
